import { render, staticRenderFns } from "./DatatableReceberItem.vue?vue&type=template&id=0ecdbb56"
import script from "./DatatableReceberItem.vue?vue&type=script&lang=js"
export * from "./DatatableReceberItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports